import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ScheduleNotSetIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2012 3.8484H14.4086V2.55721C14.4086 2.48385 14.3941 2.41121 14.366 2.34346C14.3378 2.27571 14.2965 2.21418 14.2445 2.16241C14.1925 2.11064 14.1308 2.06965 14.0629 2.04178C13.995 2.01391 13.9223 1.99971 13.8489 2C13.7754 2.0003 13.7026 2.01506 13.6348 2.04344C13.567 2.07183 13.5055 2.11329 13.4537 2.16544C13.4019 2.2176 13.361 2.27944 13.3331 2.34742C13.3052 2.41541 13.2911 2.48822 13.2914 2.56168V3.8484H6.75791V2.55721C6.75672 2.40863 6.69668 2.26657 6.59093 2.16214C6.48518 2.05771 6.34234 1.99941 6.19367 2C6.12008 2 6.04722 2.01456 5.97928 2.04284C5.91135 2.07112 5.84969 2.11257 5.79786 2.16478C5.74603 2.217 5.70506 2.27896 5.67731 2.34708C5.64955 2.4152 5.63557 2.48813 5.63616 2.56168V3.8484H4.79877C4.05628 3.84899 3.34441 4.14419 2.8196 4.66912C2.2948 5.19406 2 5.90577 2 6.64784V15.2028C2 15.9447 2.29487 16.6561 2.81974 17.1807C3.34461 17.7053 4.05649 18 4.79877 18H15.2012C15.9435 18 16.6554 17.7053 17.1803 17.1807C17.7051 16.6561 18 15.9447 18 15.2028V6.64784C18 5.90577 17.7052 5.19406 17.1804 4.66912C16.6556 4.14419 15.9437 3.84899 15.2012 3.8484ZM4.79877 4.96728H5.64064V5.35665C5.64063 5.50365 5.69876 5.64471 5.80234 5.74907C5.90593 5.85344 6.04659 5.91267 6.19367 5.91385C6.26708 5.91385 6.33976 5.89936 6.40754 5.87122C6.47533 5.84308 6.53689 5.80184 6.58869 5.74986C6.64049 5.69788 6.68151 5.63619 6.70939 5.56833C6.73728 5.50047 6.75148 5.42777 6.75119 5.35441V4.96728H13.2936V5.35665C13.2948 5.50445 13.3542 5.64583 13.459 5.75014C13.5638 5.85444 13.7055 5.91327 13.8533 5.91385C13.9267 5.91385 13.9994 5.89936 14.0672 5.87122C14.135 5.84308 14.1966 5.80184 14.2484 5.74986C14.3002 5.69788 14.3412 5.63619 14.3691 5.56833C14.3969 5.50047 14.4112 5.42777 14.4109 5.35441V4.96728H15.199C15.6442 4.96787 16.071 5.14488 16.3858 5.4595C16.7005 5.77412 16.8777 6.20066 16.8783 6.6456V7.90098H3.11951V6.64784C3.11951 6.20251 3.29636 5.77539 3.61122 5.46029C3.92607 5.14519 4.35319 4.96787 4.79877 4.96728ZM15.2012 16.8811H4.79877C4.3534 16.8811 3.92627 16.7043 3.61135 16.3895C3.29643 16.0748 3.11951 15.6479 3.11951 15.2028V9.01986H16.8805V15.2028C16.8805 15.6479 16.7036 16.0748 16.3886 16.3895C16.0737 16.7043 15.6466 16.8811 15.2012 16.8811Z"
      fill="currentColor"
    />
    <g clipPath="url(#clip0_schedule_not_set)">
      <path
        d="M8.18621 14.4267C8.07643 14.433 7.96845 14.3966 7.88506 14.3249C7.7206 14.1596 7.7206 13.8925 7.88506 13.7272L11.4862 10.1281C11.6572 9.96809 11.9257 9.97699 12.0857 10.1479C12.2305 10.3025 12.2389 10.5402 12.1055 10.7046L8.48312 14.3249C8.40081 14.3955 8.29456 14.4319 8.18621 14.4267Z"
        fill="currentColor"
      />
      <path
        d="M11.7833 14.4266C11.672 14.4262 11.5653 14.382 11.4863 14.3037L7.88519 10.7046C7.73283 10.5267 7.75355 10.2591 7.93147 10.1068C8.09027 9.9709 8.32448 9.9709 8.48326 10.1068L12.1056 13.7059C12.2766 13.866 12.2855 14.1342 12.1254 14.3051C12.119 14.3119 12.1124 14.3185 12.1056 14.3249C12.0169 14.402 11.9002 14.4388 11.7833 14.4266Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_schedule_not_set">
        <rect
          fill="white"
          height="4.47552"
          transform="translate(7.76172 10.0049)"
          width="4.47803"
        />
      </clipPath>
    </defs>
  </svg>
);

ScheduleNotSetIcon.propTypes = {
  ...sizePropsTypes,
};

export default ScheduleNotSetIcon;
